
import React from 'react';
import Blog from '../components/Blog';

const BlogPage = () => {
  return (
    <section className="bg-light py-5">
      <Blog />
    </section>
  );
};

export default BlogPage;
